import { CheckOutlined, InfoCircleOutlined, LoadingOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";

import axiosConfig from "config/axios";
import { parse } from "fast-qs";
import requestErrorHandler from "utils/requestErrorHandler";
import styles from "./buildmate.module.css";
import { useLocation } from "react-router";

export default function VerifyBuildMatePayment() {
  const { search } = useLocation();
  const { reference } = parse(search) as {
    reference: string;
  };
  const [token, setToken] = useState<string>("");
  const [isConfirming, setIsConfirming] = useState<boolean>(true);
  const [isSuccessful, setIsSuccessful] = useState<boolean>(false);


  const getOrderByReference = async () => {
    try {
      const { data } = await axiosConfig.get(`homeowner/get-order-by-payment-reference?reference=${reference}`)
      await updateOrderStatus(data.order.id)
    } catch (error) {
      requestErrorHandler(error);
    }
  }
  const updateOrderStatus = async (homeOwnerOrderID: string) => {
    try {
      await axiosConfig.put(
        "homeowner/update-order",
        {
          homeOwnerOrderID,
          reference,
          status: 'pending'
        },
        { headers: { Authorization: "Bearer " + token } }
      );

      setTimeout(() => {
        void confirmPayment();
      }, 3000);
    } catch (error) {
      requestErrorHandler(error);
    }
  }

  const confirmPayment = async () => {
    try {
      await axiosConfig.post(`homeowner/verify-payment`, { reference }, { headers: { Authorization: "Bearer " + token } })
      setIsConfirming(false);
      setIsSuccessful(true);
    } catch (error) {
      requestErrorHandler(error);
    }
  };

  let runOnce = true;
  useEffect(() => {
    if (runOnce === true) {
      runOnce = false;
      getOrderByReference();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const _token: string = localStorage.getItem("token")?.toString()!;
    setToken(_token);
  }, []);

  if (isConfirming) {
    return (
      <div>
        <div className={styles.payment}>
          <div className={styles.card}>
            <span data-loading className={styles.icon}>
              {<LoadingOutlined />}
            </span>
            <h1>Verifying your payment</h1>
            <p>Please wait while we verify your payment</p>
          </div>
        </div>
      </div>
    );
  }
  if (isSuccessful) {
    setTimeout(()=>{
      window.location.href = "#success"
    }, 3000)
    return (
      <div>
        <div className={styles.payment}>
          <div className={styles.card}>
            <span data-success className={styles.icon}>
              <CheckOutlined />
            </span>
            <h1>Payment Successful!</h1>
            <p>We have received your payment and we will process your order shortly</p>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div>
      <div className={styles.payment}>
        <div className={styles.card}>
          <span data-error className={styles.icon}>
            <InfoCircleOutlined />
          </span>
          <h1>Unable to verify your payment</h1>
          <p>
            Please contact Buildmate at <a href="mailto:info@materialspro.ng">info@materialspro.ng</a> or by phone at{" "}
            <a href="tel:+23409165407978">09165407978 </a> for further assistance or inquiries.,
          </p>
          <a href="#fail" className={styles["back-btn"]}>
            Go back
          </a>
        </div>
      </div>
    </div>
  );
}
